/* =========================================================================
   Sticky Header — reveals a separate condensed bar when the user scrolls UP
   (and is comfortably past the main header), hides it on scroll-down and near
   the top. Independent of the theme's built-in StickyHeader.
   ========================================================================= */
(function () {
  class BubbleStickyHeader extends HTMLElement {
    connectedCallback() {
      // Reveal only once the user is well past the main header.
      this.revealThreshold = 400;
      // Ignore micro-scrolls so the bar doesn't flicker.
      this.delta = 6;

      this.lastScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.ticking = false;
      this.visible = false;

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const current = window.pageYOffset || document.documentElement.scrollTop || 0;
      const diff = current - this.lastScroll;

      if (Math.abs(diff) < this.delta) return;

      if (diff < 0 && current > this.revealThreshold) {
        // Scrolling up, past the threshold → reveal.
        this.show();
      } else if (diff > 0 || current <= this.revealThreshold) {
        // Scrolling down, or back near the top → hide (let the main header own it).
        this.hide();
      }

      this.lastScroll = current;
    }

    show() {
      if (this.visible) return;
      this.visible = true;
      this.classList.add('is-visible');
    }

    hide() {
      if (!this.visible) return;
      this.visible = false;
      this.classList.remove('is-visible');
    }
  }

  if (!customElements.get('bubble-sticky-header')) {
    customElements.define('bubble-sticky-header', BubbleStickyHeader);
  }
})();
